

import React, { useState,useEffect,useRef} from 'react';
import {motion,useScroll} from 'framer-motion';
import './App.css';
import 'animate.css';
import View from './view';
import making from '../src/video/making1.mp4';
import DialogForm from './components/DialogForm';



const Home = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const {scrollYProgress}=useScroll();
  const openDialogPopup = () => {
    setIsDialogOpen(true);
  };

  const closeDialogPopup = () => {
    setIsDialogOpen(false);
  };
  
  return (

    <div id="home" >
  <div style={{position: 'relative', width:'100%', backgroundAttachment:'fixed', objectFit:'contain'}}>
    <video autoPlay loop muted style={{position: 'absolute', top: 0, left: 0, width:'100%', height:'100%', objectFit:'cover'}}>
        <source src={making} type="video/mp4" />
        Your browser does not support the video tag.
    </video>

    <div className="p-5 bg-dark  bg-opacity-50 animate__animated animate__fadeIn animate__delay-1s">
    <p className="pt-50 uppercase  text-white letter-spacing text-center">THE EXEMPLARY PATH FORWARD WITH</p>
<h1 className="text-2xl leading-[65px] tracking-[4px] text-white text-center">BuildFortune Construction</h1>
<p className="text-5md tracking-[1px]   uppercase text-center">Join us on this journey of transforming visions into reality. Build your fortune with BuildFortune,<br></br>where dreams are built, and futures are fortified.</p>
<div className="text-center mt-5" style={{marginBottom:'135px'}} >
<button type="button" className=" btn btn-small text-white " style={{backgroundColor:'rgb(134, 198, 39)',border:'none',borderRadius:'0px',letterSpacing:'1px'}} onClick={openDialogPopup}>Build Your Dream House</button>
<DialogForm isOpen={isDialogOpen} onClose={closeDialogPopup}/> 
</div>
</div>
</div>


<View/>


</div>
  )
}

export default Home
